import React from 'react'
import { Container, withStyles } from '@material-ui/core'

import { UsersExportDownload } from '../../../features/users-export-download'
import { usersExportDownloadPageStyles } from './users-export-download.styles'

export const UsersExportDownloadPage = withStyles(usersExportDownloadPageStyles)(({ classes }) => {
  return (
    <div className={classes.root}>
      <Container className={classes.container} maxWidth="md">
        <UsersExportDownload />
      </Container>
    </div>
  )
})
